
function showFullScreen (show, overlay) {
  if (overlay) overlay.scrollTop = 0
  const body = window.document.getElementById('activity')
  body.classList.toggle('scroll-off', show)
}

export const show = showFullScreen.bind(null, true)
export const hide = showFullScreen.bind(null, false)
